import BasicInput from '@shared/ui/forms/inputs/BasicInput';
import { validateMaxLength } from '@utils/validation';
import { useTranslation } from 'react-i18next';

export default function TelegramInput({ control, errors, isRequired = false }) {
  const { t } = useTranslation();

  return (
    <BasicInput
      control={control}
      name="telegram"
      label="Telegram"
      validation={(value) => validateMaxLength(value, 255)}
      error={errors.telegram}
      isRequired={isRequired}
      placeholder={isRequired ? 'username' : t('optional')}
      icon="telegram-input"
    />
  );
}
